import { reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { setValue, fetchGroupCategories, fetchSuggestedProdNum, fetchProductsByCategory, fetchDepCategories,
  fetchSuggestDigit, clearSuggestDigit, fetchPackageTypes, fetchMeasurementUnit, fetchConvertableProducts } from '../../actions/products_actions';
import { ProductFormNavigation_1, ProductFormNavigation_2, ProductFormNavigation_3, PackageTypes } from '../../components/Products/productFormNavigation';

let productFormNavigation_1 = reduxForm({
    form: 'productFormNavigation_1',
})(ProductFormNavigation_1);

const selector = formValueSelector('productFormNavigation_1')

function mapStateToProps(state) {
  const Category = selector(state, 'Category')
  const Group = selector(state, 'Group')
  const Department = selector(state, 'Department')
  const IsLarge = selector(state, 'IsLarge')
  const LastDigit = selector(state, 'LastDigit')
  const Name = selector(state, 'Name')
  const Description = selector(state, 'Description')
  return {
    Category,
    Group,
    Department,
    IsLarge,
    LastDigit,
    Name,
    Description,
    existingProd: state.products.all,
    existingProdError: state.products.error,
    existingProdIsLoading: state.products.isLoading,
    fetchingSuggestedProdNum: state.products.fetchingSuggestedProdNum,
    suggestedProdNumFetched: state.products.suggestedProdNumFetched,
    suggestedProdNumFetchError: state.products.suggestedProdNumFetchError,
    groupCategories: state.products.groupCategories,
    depCategories: state.products.depCategories,
    groupCategoryError: state.products.groupCategoryError,
    groupCategoryIsLoading: state.products.groupCategoryIsLoading,
    fetchingSuggestDigit: state.products.fetchingSuggestDigit,
    suggestDigitFetched: state.products.suggestDigitFetched,
    suggestDigitFetchError: state.products.suggestDigitFetchError,
    fetchingConvertableProducts: state.products.fetchingConvertableProducts,
    convertableProductsFetchError: state.products.convertableProductsFetchError,
  }
}

productFormNavigation_1 = connect(mapStateToProps, {
  setValue, fetchGroupCategories, fetchSuggestedProdNum,
  fetchProductsByCategory, fetchSuggestDigit, clearSuggestDigit, fetchDepCategories
})(productFormNavigation_1)
export default productFormNavigation_1


let productFormNavigation_2 = reduxForm({
    form: 'productFormNavigation_2',
})(ProductFormNavigation_2);

const selector_2 = formValueSelector('productFormNavigation_2')

function mapStateToProps_2(state) {
  const ProdType = selector_2(state, 'ProdType');
  const PackageType = selector_2(state, 'PackageType');
  const PackageSize_1 = selector_2(state, 'PackageSize_1');
  const PackageType_2 = selector_2(state, 'PackageType_2');
  const PackageSize_2 = selector_2(state, 'PackageSize_2');
  const MeasureUnit_2 = selector_2(state, 'MeasureUnit_2');
  const NetWeight_1 = selector_2(state, 'NetWeight_1');
  const NetWeight_2 = selector_2(state, 'NetWeight_2');
  const ProductCost = selector_2(state, 'ProductCost');
  const RefPrice = selector_2(state, 'RefPrice');
  const LowestSalePrice = selector_2(state, 'LowestSalePrice');
  return {
    ProdType,
    PackageType,
    PackageSize_1,
    PackageType_2,
    PackageSize_2,
    MeasureUnit_2,
    NetWeight_1,
    NetWeight_2,
    ProductCost,
    RefPrice,
    LowestSalePrice,
    packageTypesFetched: state.products.packageTypesFetched,
    measurementUnitFetched: state.products.measurementUnitFetched,
  }
}

productFormNavigation_2 = connect(mapStateToProps_2, { setValue, fetchPackageTypes, fetchMeasurementUnit })(productFormNavigation_2)
export { productFormNavigation_2 }


let productFormNavigation_3 = reduxForm({
    form: 'productFormNavigation_3',
})(ProductFormNavigation_3);

const selector_3 = formValueSelector('productFormNavigation_3')

function mapStateToProps_3(state) {
  const ConvertNum = selector_3(state, 'ConvertNum');
  const SmallProdType = selector_3(state, 'SmallProdType');
  const SmallPackageType = selector_3(state, 'SmallPackageType');
  const ConvertType = selector_3(state, 'ConvertType');
  const GeneralNum = selector_3(state, 'GeneralNum');
  return {
    ConvertNum,
    SmallProdType,
    SmallPackageType,
    ConvertType,
    GeneralNum,
    packageTypesFetched: state.products.packageTypesFetched,
    fetchingConvertableProducts: state.products.fetchingConvertableProducts,
    convertableProductsFetched: state.products.convertableProductsFetched,
    convertableProductsFetchError: state.products.convertableProductsFetchError,
  }
}

productFormNavigation_3 = connect(mapStateToProps_3, { setValue, fetchPackageTypes, fetchConvertableProducts })(productFormNavigation_3)

export { productFormNavigation_3 }



// WEBPACK FOOTER //
// ./master/jsx/containers/Products/productFormNavigation.jsx